import { Flex } from '@libs/ui/ds'
import { AuthNavbarProvider, AuthNavbar } from '@spa/components/AuthNavbar'
import { Outlet } from 'react-router-dom'

import { AuthHeroImage } from '../components/AuthHeroImage/AuthHeroImage'

export const SignupSplitLayout = () => {
  return (
    <AuthNavbarProvider>
      <div className='flex'>
        <div className='w-full'>
          <Flex className='md:max-h-20'>
            <AuthNavbar />
          </Flex>
          <Flex className='mt-12 size-full lg:-mt-20'>
            <Flex className='md:m-auto'>
              <Flex className='w-screen px-4 py-8 md:max-w-120'>
                <Outlet />
              </Flex>
            </Flex>
          </Flex>
        </div>
        <div className='hidden min-h-screen w-1/2 max-w-[40rem] bg-brand-beige-50 pt-20 lg:block'>
          <AuthHeroImage />
        </div>
      </div>
    </AuthNavbarProvider>
  )
}
